import { css } from 'emotion';

import { colors } from '../../styles';

export const icon = css`
  width: 42px;
  height: 42px;
  color: ${colors.gray.dark};
`;
